/**
 *
 */
import React from 'react'
import { Table, Divider, DatePicker, Button, Tooltip, Input, Tag } from 'antd'
import moment from 'moment'
import Cell from '../../components/Cell'
import Crud from '../../components/Crud'
import Api from '../../Api'
import Exception from '../../Exception'
import Adjuntos from './Components/SolicitudPagoAdjuntos'
import Bitacora from './Components/Bitacora'
import Pagos from './Components/SolicitudPagoPagos'
import SolicitarPago from './Components/NuevaSolicitudPago'
import _ from 'lodash'
import { ImportesSolPago } from './Components/importesSolPago'

export class PagosSolicitadosCxp extends React.Component {
  /**
   * Constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.columns = Cell.buildList([
      { width: '25%', title: 'INFORMACIÓN', dataIndex: 'ordenCompra.sConsecutivo', render: (__, record) =>
        <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          <Tooltip title={`No fact o ref, concepto: ${record.sConcepto || '[SIN CONCEPTO]'}`}>
            <Tag color='orange'>{record.sReferencia}</Tag>
          </Tooltip>

          <Tooltip title='Orden de compra (OC) u Orden de Servicio (OS)'>
            <Tag color='purple'>{_.get(record, 'ordenCompra.sConsecutivo')}</Tag>
          </Tooltip>

          {record.entrada ? (
            <Tooltip title='Folio de entrada'>
              <Tag>{record.entrada.sConsecutivo}</Tag>
            </Tooltip>
          ) : null}

          <Tooltip title='Status de su solicitud de pago'>
            <Tag>{record.sEstado}</Tag>
          </Tooltip>
        </div>
      },
      { width: '30%', title: 'IMPORTES', dataIndex: 'dImporteOriginal', render: (_, record) => (
        <ImportesSolPago
          {...record}
          style={{
            flexWrap: 'wrap'
          }}
        />
      )},
      { width: '10%', title: ' ', dataIndex: 'sFolio', render: (_, record) => (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div>
            {record.sEstado !== 'PENDIENTE' ? null : (
              <Tooltip title='Editar'>
                <Button
                  size='small'
                  shape='circle-outline'
                  icon='edit'
                  style={{ marginRight: 7 }}
                  onClick={() => this.solicitarPago.load(record.iId)}
                />
              </Tooltip>
            )}
            <Tooltip title='Adjuntos'>
              <Button
                size='small'
                shape='circle-outline'
                icon='link'
                style={{ marginRight: 7 }}
                onClick={() => this.adjuntos.load(record.iId)}
              />
            </Tooltip>
            <Tooltip title='Pagos autorizados'>
              <Button
                size='small'
                shape='circle-outline'
                icon='dollar'
                style={{ marginRight: 7 }}
                onClick={() => this.pagos.load(record.iId)}
              />
            </Tooltip>
            {/* {<Tooltip title='Registro de bitacora'>
              <Button
                size='small'
                shape='circle-outline'
                icon='clock-circle'
                style={{ marginRight: 7 }}
                onClick={() =>
                  this.bitacora.load({
                    from: record.dInicioPeriodo,
                    to: record.dTerminoPeriodo,
                    special: record.sEspecial,
                  })
                }
              />
            </Tooltip>} */}
          </div>
        </div>
      )}
    ])

    this.state = {
      loading: false,
      inicio: -1,
      termino: -1,
      search: '',
      data: [],
      lookup: [],
    }

    this.solicitarPago = null
  }

  /**
   * Invocado cuando el componente es montado
   */
  componentDidMount() {
    const fecha = moment()
    this.fetch(
      fecha.startOf('month').format('YYYY-MM-DD'),
      fecha.endOf('month').format('YYYY-MM-DD')
    )
  }

  /**
   * Cargar
   *
   */
  fetch = async(inicio = -1, termino = -1, search = '') => {
    try {
      this.setState({ loading: true, query: { inicio, termino } })

      const likeSearch = {$like: `%${search}%`}
      const filter = search.length > 0 ? {
        $or: [
          { sFolio: likeSearch },
          { sReferencia: likeSearch },
          { '$entrada.sConsecutivo$': likeSearch },
          { '$entrada.sReferencia$': likeSearch },
        ],
      } : {
        $or: [
          { dFecha: { $between: [inicio, termino]} },
          { sEstado: { $ne: 'PAGADA' } },
        ]
      }

      const response = await querySolicitudesPago(filter)

      this.setState({
        data: response.data,
        loading: false,
        inicio,
        termino,
        search,
      })
    } catch (error) {
      this.setState({
        data: [],
        loading: false,
      })
      Exception.load(error).show()
    }
  }

  /**
   * Render
   */
  render() {
    const crud = (
      <Crud
        buttons={['add', 'reload']}
        onReload={() =>
          this.fetch(
            this.state.inicio,
            this.state.termino,
            this.state.search
          )
        }
        onAdd={() => this.solicitarPago.showModal()}
      />
    )

    const tableTitle = (
      <div>
        <DatePicker.RangePicker
          defaultValue={[moment().startOf('month'), moment().endOf('month')]}
          onChange={
            (items, fechas) =>
              this.fetch(
                fechas[0].length > 0 ? fechas[0] : -1,
                fechas[1].length > 0 ? fechas[1] : -1,
                this.state.search,
              )
          } />
        <Divider type='vertical' />
        {crud}
        <Divider type='vertical'/>
        <Input.Search
          placeholder='Buscar'
          style={{ width: 185 }}
          onSearch={value =>
            this.fetch(this.state.inicio, this.state.termino, value.trim())
          }
          allowClear
        />
      </div>
    )

    return (
      <div style={{ flex: 1 }}>
        <Pagos ref={ref => this.pagos = ref} />
        <Adjuntos ref={ref => this.adjuntos = ref} />
        <Bitacora ref={ref => this.bitacora = ref} />

        <SolicitarPago
          ref={ref => this.solicitarPago = ref}
          onCreate={() => this.fetch(this.state.inicio, this.state.termino, this.state.search)}
        />

        <Table
          rowKey='iId'
          size='small'
          rowClassName='row-pure'
          dataSource={this.state.data}
          columns={this.columns}
          loading={this.state.loading}
          pagination={false}
          title={() => tableTitle}
        />
      </div>
    )
  }
}

/**
 *
 * @param {*} filter
 * @returns
 */
function querySolicitudesPago(filter) {
  return Api.query({
    model: 'CxpOrdenPago',
    attributes: [
      'iId',
      'sReferencia',
      'sEspecial',
      'sEstado',
      'sFolio',
      'sConcepto',
      'dTipoCambio',
      'dImporteOriginal',
      [{ literal: '@importes_info := fn_cxp_orden_pago_importes_info(CxpOrdenPago.iId)' }, 'importes_info'],
      [{ literal: 'json_extract(@importes_info, \'$.pagado\')' }, 'dImportePagado'],
      [{ literal: 'json_extract(@importes_info, \'$.pendiente_pagar\')' }, 'dImportePendiente'],
      'dFecha',
      'dFechaIngreso',
      'dFechaVencimiento',
      'dInicioPeriodo',
      'dTerminoPeriodo',
    ],

    include: [
      {
        as: 'ordenCompra', attributes: ['sConsecutivo'],
      },
      // { as: 'proyecto', attributes: ['sAlias'] },
      { as: 'requisicion', attributes: ['iMaquinaria'] },
      { as: 'entrada', required: false, attributes: ['sConsecutivo'] },
      { as: 'moneda', attributes: ['sCodigo'] },
    ],

    where: {
      iIdProveedor: Api.getProviderId(),
      iActivo: true,
      ...filter
    },
    order: [
      ['iId', 'DESC']
    ]
  })
}

